import { Box, Paper, SxProps, Theme } from "@mui/material";

import { ReactNode } from "react";
import { useTheme } from "../../hooks";

export const ListContainer = (props: {
  header?: ReactNode;
  tableContainer?: ReactNode;
  footer?: ReactNode;
  fullHeight?: boolean;
  type?: "main" | "grid";
  customStyle?: SxProps<Theme>;
}) => {
  const theme = useTheme();

  let _sx: SxProps<Theme> | undefined = {
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    overflow: props.fullHeight ? "auto" : "unset",
    height: props.fullHeight ? "100%" : "auto",
  };

  if (props.customStyle) {
    _sx = {..._sx, ...props.customStyle};
  }

  if (props.type === "grid") {
    const gridSx: SxProps<Theme> = {
      boxShadow: "none",
      border: `1px solid ${theme.palette.border.main}`,
      //borderRadius: "0px",
      //".MuiTableCell-root": { border: "1px solid black" },
    };

    _sx = { ..._sx, ...gridSx } as SxProps<Theme>;
  }

  return (
    <Paper sx={_sx}>
      <>
        {props.header && (
          <Box
            display="grid"
            alignItems={"center"}
            fontSize="1.15rem"
            //fontWeight={"light"}
            py={1}
            px={3.5}
            minHeight="50px"
            borderBottom={`1px solid ${theme.palette.border.main}`}
            flexShrink={0}
          >
            {props.header}
          </Box>
        )}

        <Box display="flex" flexGrow={1} overflow="auto" minHeight="100px" borderRadius={3}>
          {props.tableContainer}
        </Box>

        {props.footer && (
          <Box
            sx={{
              borderTop: `1px solid ${theme.palette.border.main}`,
              fontSize: "0.875rem", // match table font
            }}
            px={2}
            py={1.5}
            flexGrow={0}
            borderRadius="inherit"
          >
            {props.footer}
          </Box>
        )}
      </>
    </Paper>
  );
  //return type === "main" ? <Paper sx={_sx}>{renderBody()}</Paper> : <Paper sx={_sx}>{renderBody()}</Paper>;
};
